import * as Yup from 'yup';

const kitComponentSchema = Yup.object().shape({
  sku: Yup.string().required(),
  quantity: Yup.number()
    .transform((value, originalValue) => (originalValue === '' ? undefined : value))
    .typeError('Debe ser un número')
    .integer('Debe ser un número entero')
    .min(1, 'El mínimo es 1')
    .required('Campo requerido'),
});

export const createKitSchema = Yup.object().shape({
  name: Yup.string().required('Campo requerido'),
  sku: Yup.string()
    .required('Campo requerido')
    .matches(/^[a-zA-Z0-9_-]+$/, 'Solo se permiten letras, números, guiones y guiones bajos'),
  price: Yup.number()
    .transform((value, originalValue) => (originalValue === '' ? undefined : value))
    .typeError('Debe ser un número')
    .integer('Debe ser un número entero')
    .required('Campo requerido'),
  components: Yup.array()
    .of(kitComponentSchema)
    .min(2, 'Selecciona al menos 2 productos para armar el Kit')
    .required('Selecciona los productos que conforman el Kit'),
});

export type CreateKitFormData = Yup.InferType<typeof createKitSchema>;
